import OwnerService from "./src/owner-service";

const Owner = new OwnerService();

Owner.install = function (vue) {
  vue.observable(Owner);
};

if (window.mx.getUser) {
  let userFn = window.mx.getUser;
  window.mx.getUser = () => {
    return Owner.getInfo(userFn);
  };
}

export default Owner;
